import React from "react";

const Note = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="m23.333 21.556-.207.011a1.779 1.779 0 0 0-1.559 1.559l-.011.207V34H3.775A1.77 1.77 0 0 1 2 32.234V3.766C2 2.791 2.791 2 3.766 2h28.468C33.209 2 34 2.796 34 3.775v17.78H23.333ZM34 25.11l-8.889 8.884V25.11H34Z"
            fill={fill}
        />
    </svg>
);

export default Note;
